module.exports = __webpack_public_path__ + "img/sellSuccess.e09af1fb.png";